import { useEffect } from 'react';

import { RecordsData, setPageRecords } from '@app/utils';
import { SetState } from '@app/constants';

export interface PagingData<T> extends RecordsData<T> {
  areRecordsFetched: boolean;
  isNewPageRequest: boolean;
  setInstanceIdScrollTo?: SetState<string>;
}

export const usePaging = <T>({
  areRecordsFetched,
  isNewPageRequest,
  pageNumber,
  records,
  setPages,
}: PagingData<T>) => {
  useEffect(() => {
    if (!isNewPageRequest) {
      setPages([]);
    }

    if (areRecordsFetched) {
      setPageRecords({ pageNumber, records, setPages });
    }
  }, [areRecordsFetched, records, pageNumber, setPages, isNewPageRequest]);
};
